import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKolltukuBardh = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 10,
	viewBox: "0 0 18 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_8982",
		"data-name": "Path 8982",
		d: "M17.364,8.571A1.548,1.548,0,0,0,15.727,10v2.143H4.273V10A1.548,1.548,0,0,0,2.636,8.571,1.548,1.548,0,0,0,1,10v3.571A1.548,1.548,0,0,0,2.636,15H17.364A1.548,1.548,0,0,0,19,13.571V10A1.548,1.548,0,0,0,17.364,8.571ZM14.909,5H5.091A1.548,1.548,0,0,0,3.455,6.429V7.964A2.179,2.179,0,0,1,5.091,9.979v1.45h9.818V9.979a2.192,2.192,0,0,1,1.636-2.014V6.429A1.548,1.548,0,0,0,14.909,5Z",
		transform: "translate(-1 -5)",
		fill: "#fff"
	})
});
export { SvgKolltukuBardh as ReactComponent };
